import actions from './actions'
import { SnackbarOptions } from './snackbar-options'
import * as types from './types'

const state = {
  snackbar: new SnackbarOptions()
}

const mutations = {
  [types.SET_SNACKBAR_SUCCESS](state, options) {
    state.snackbar = SnackbarOptions.notifySuccess(options)
  },
  [types.SET_SNACKBAR_ERROR](state, options) {
    state.snackbar = SnackbarOptions.notifyError(options)
  },
  [types.SET_SNACKBAR_WARNING](state, options) {
    state.snackbar = SnackbarOptions.notifyWarning(options)
  },
  [types.SET_SNACKBAR](state, options) {
    state.snackbar = SnackbarOptions.notify(options)
  },
  [types.SET_SNACKBAR_TO_HIDE](state) {
    state.snackbar = new SnackbarOptions()
  }
}

export default {
  state,
  mutations,
  actions
}
